import { useColorMode } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { buttonBoxColorStyle } from '../constants/HomeStyleConst';

export default function PhotoSearchLinkButton() {
  const navigate = useNavigate();
  const { colorMode } = useColorMode();

  return (
    <button
      type="button"
      className="w-[38px] h-[38px] p-[2px] flex items-center justify-center rounded-full cursor-pointer"
      onClick={() => navigate('/image-search')}
      style={buttonBoxColorStyle[colorMode].imageSearchButtonStyle}
    >
      <div className="w-full h-full bg-pure-white dark:bg-pure-black rounded-full flex items-center justify-center">
        <SpinningGradientIcon />
      </div>
    </button>
  );
}

const SpinningGradientIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="Spinning Gradient Icon"
      role="img"
    >
      <path
        d="M8.11304 7.46066C10.139 5.7054 13.2348 5.89164 15.0271 7.87574C16.6323 9.65374 16.646 12.2704 15.1755 14.0588L16.6051 15.6437C16.9644 16.0419 16.9273 16.6497 16.5209 17.0021C16.1144 17.354 15.4924 17.3177 15.1327 16.9197L13.6603 15.2873C11.7059 16.3088 9.22305 15.931 7.69072 14.2349C5.89871 12.2502 6.08731 9.2163 8.11304 7.46066ZM13.5547 9.15176C12.4821 7.96444 10.6298 7.8528 9.4171 8.90299C8.20432 9.95377 8.0906 11.7694 9.16314 12.9574C10.2357 14.1451 12.088 14.2564 13.3007 13.2062C14.5134 12.1554 14.6272 10.3398 13.5547 9.15176Z"
        fill="url(#paint0_linear_64_16910)"
      />
      <path
        d="M20.4607 16.6824C21.0202 16.6827 21.4737 17.1266 21.4737 17.6747V20.224C21.4737 20.2967 21.4671 20.3683 21.4551 20.4378C21.4266 20.6031 21.3663 20.7578 21.2796 20.8948C21.1734 21.0627 21.0273 21.2059 20.8559 21.3099C20.7159 21.3948 20.5581 21.4539 20.3893 21.4818C20.3183 21.4936 20.2453 21.5 20.1711 21.5H17.5686C17.0091 21.5 16.5559 21.0558 16.5556 20.5077C16.5556 19.9594 17.0089 19.514 17.5686 19.514H19.3621C19.4086 19.5136 19.4459 19.4771 19.4463 19.4315V17.6747C19.4463 17.1264 19.9009 16.6824 20.4607 16.6824Z"
        fill="url(#paint1_linear_64_16910)"
      />
      <path
        d="M3.513 7.31755C2.95344 7.3173 2.5 6.87344 2.5 6.32525L2.5 3.77602C2.50001 3.70333 2.50657 3.63173 2.51855 3.56218C2.54705 3.39694 2.60742 3.24225 2.69404 3.10516C2.80028 2.93728 2.9464 2.79413 3.11779 2.69008C3.25775 2.60523 3.41563 2.54608 3.58434 2.51817C3.65535 2.50643 3.72841 2.5 3.80263 2.5L6.40504 2.5C6.96463 2.5 7.41774 2.94421 7.41804 3.4923C7.41804 4.04064 6.96482 4.486 6.40504 4.486L4.6116 4.486C4.56509 4.48635 4.52783 4.52291 4.52743 4.56846L4.52743 6.32525C4.52743 6.87359 4.07278 7.31755 3.513 7.31755Z"
        fill="url(#paint2_linear_64_16910)"
      />
      <path
        d="M7.31755 20.4668C7.3173 21.0264 6.87344 21.4798 6.32525 21.4798H3.77602C3.70333 21.4798 3.63173 21.4732 3.56218 21.4613C3.39694 21.4328 3.24225 21.3724 3.10516 21.2858C2.93728 21.1795 2.79413 21.0334 2.69008 20.862C2.60523 20.7221 2.54608 20.5642 2.51817 20.3955C2.50643 20.3245 2.5 20.2514 2.5 20.1772L2.5 17.5748C2.5 17.0152 2.94421 16.5621 3.4923 16.5618C4.04064 16.5618 4.486 17.015 4.486 17.5748V19.3682C4.48635 19.4147 4.52291 19.452 4.56846 19.4524H6.32525C6.87359 19.4524 7.31755 19.907 7.31755 20.4668Z"
        fill="url(#paint3_linear_64_16910)"
      />
      <path
        d="M16.6824 3.51305C16.6827 2.95349 17.1266 2.50005 17.6747 2.50005L20.224 2.50005C20.2967 2.50006 20.3683 2.50662 20.4378 2.5186C20.6031 2.5471 20.7578 2.60747 20.8948 2.69409C21.0627 2.80033 21.2059 2.94645 21.3099 3.11784C21.3948 3.2578 21.4539 3.41568 21.4818 3.58439C21.4936 3.6554 21.5 3.72846 21.5 3.80268V6.40509C21.5 6.96468 21.0558 7.41779 20.5077 7.41809C19.9594 7.41809 19.514 6.96487 19.514 6.40509V4.61165C19.5136 4.56514 19.4771 4.52788 19.4315 4.52748L17.6747 4.52748C17.1264 4.52748 16.6824 4.07283 16.6824 3.51305Z"
        fill="url(#paint4_linear_64_16910)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_64_16910"
          x1="2.5"
          y1="2.5"
          x2="21.6549"
          y2="2.65746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FFF" />
          <stop offset="1" stopColor="#CF6AFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_64_16910"
          x1="2.5"
          y1="2.5"
          x2="21.6549"
          y2="2.65746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FFF" />
          <stop offset="1" stopColor="#CF6AFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_64_16910"
          x1="2.5"
          y1="2.5"
          x2="21.6549"
          y2="2.65746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FFF" />
          <stop offset="1" stopColor="#CF6AFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_64_16910"
          x1="2.5"
          y1="2.5"
          x2="21.6549"
          y2="2.65746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FFF" />
          <stop offset="1" stopColor="#CF6AFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_64_16910"
          x1="2.5"
          y1="2.5"
          x2="21.6549"
          y2="2.65746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FFF" />
          <stop offset="1" stopColor="#CF6AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

